import { loadOptions } from '../formset.js';

export default function (...args)
{
	return {
		options: [
			{ value: '0', label: 'Nenhum' },
			{ value: '1', label: 'Presencial' },
			{ value: '2', label: 'Internet' },
			{ value: '3', label: 'Teleatendimento' },
			{ value: '4', label: 'Domicílio' },
			{ value: '5', label: 'Externo' },
			{ value: '9', label: 'Outros' },
		],
		captureEvents(_this = this)
		{
			loadOptions(this.selector, this.options);
			this.safeProtoCall(_this);
		}
	};
}

